import BaseClass from "../BaseClass.js";

export default class RadioButton extends BaseClass {

    constructor(element) {
        super(element);

        const mySelf = this;
        this.url = this.$element.attr('data-url');
        this.$replaceElement = null;
        this.btnChecked = this.$element.find('input[type="radio"]:checked');

        let replaceElementId = this.$element.data('replace-element');
        if (replaceElementId != undefined) {
            let $replaceElement = $(replaceElementId);
            if ($replaceElement.length == 1) {
                this.$replaceElement = $replaceElement;
            }
        }

        // listener
        if (this.url != undefined) {
            $(this.$element).find('input[type="radio"]').on('change', function () {
                mySelf.sendData();
            });
        }
    }

    /**
     * Sendet Post Request mit Inhalt der Radiobuttons
     *
     * @returns {boolean}
     */
    sendData() {

        let mySelf = this;
        let $btnSelected = mySelf.$element.find('input[type="radio"]:checked');
        let postData = {};
        postData[$btnSelected.attr('name')] = $btnSelected.val();


        if ($btnSelected.data('post-data') != undefined) {
            const additionalParams = new URLSearchParams($btnSelected.data('post-data'));
            for (const [key, value] of additionalParams) {
                postData[key] = value;
            }
        }

        let jqxhr = $.post(mySelf.url, postData, function () {
            // nix
        }, 'json')
            .done(function (response) {
                // gewählten button speichern
                mySelf.btnChecked = mySelf.$element.find('input[type="radio"]:checked');
                mySelf.handleAjaxResponse(response);
            })
            .fail(function (response) {
                // gewählten button zurücksetzen, vorherigen button wieder aktivieren
                $btnSelected.prop('checked', false);
                mySelf.btnChecked.prop('checked', true);
            });
    }
}